module.exports = __webpack_public_path__ + "static/media/diet_recipe.2238b4d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/books/diet_recipe.svg
// module id = 409
// module chunks = 0